import React, { Component } from "react";

class Checkbox extends Component {
  render() {
    const { isChecked, id, label, inline, ...rest } = this.props;
    const classes =
      inline !== undefined ? "checkbox checkbox-inline" : "checkbox";
    return (
      <div className={classes}>
        <input id={id} type="checkbox" checked={isChecked} {...rest} />
        <label htmlFor={id}>{label}</label>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Common/checkbox.jsx